import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 20H7.37067L17.446 9.92921L15.1148 7.52013L5 17.6304V20ZM18.1572 9.21834L19.6981 7.6781C19.8799 7.49643 19.9826 7.29106 19.9984 7.062C20.0142 6.83294 19.9115 6.61968 19.6981 6.40642L18.5523 5.3006C18.339 5.08734 18.1335 4.99256 17.9201 5.00045C17.7068 5.00835 17.5092 5.11104 17.3275 5.3006L15.826 6.80135L18.1572 9.21044V9.21834Z",
		fill: "#1F3171"
	})
});
export default SvgEdit;
